import { render, staticRenderFns } from "./VOLIJAWY.vue?vue&type=template&id=2b10ca32&scoped=true"
import script from "./VOLIJAWY.vue?vue&type=script&lang=js"
export * from "./VOLIJAWY.vue?vue&type=script&lang=js"
import style0 from "./VOLIJAWY.vue?vue&type=style&index=0&id=2b10ca32&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b10ca32",
  null
  
)

export default component.exports